import { Component, NgZone, OnInit } from '@angular/core';
import { CalendarAppointment } from 'src/app/_pages/calendar/AppointmentItem';
import { CalendarService } from 'src/app/_provider/calendar/calendar.service';
import dayjs from '../../../_utils/dayjs.config';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { NavController } from '@ionic/angular';
import { CalendarPage } from 'src/app/_pages/calendar/calendar.page';
import { AuthService } from 'src/app/_provider/auth.service';
import { CalendarEditPopoverPage } from 'src/app/_pages/calendar/calendar-edit-popover/calendar-edit-popover.page';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { TicketEmployee } from 'src/app/_provider/tickets/ticket.service';
import { Subscription } from 'rxjs';
import { GeneralService } from 'src/app/_provider/general.service';
import { TicketBase } from 'src/app/_interfaces/ticket';

@Component({
    selector: 'ticket-detail-appointments',
    templateUrl: './ticket-detail-appointments.component.html',
    styleUrls: ['./ticket-detail-appointments.component.scss'],
    standalone: false
})
export class TicketDetailAppointmentsComponent {

  public appointmentsUpcoming: CalendarAppointment[] = []
  public appointmentsPast: CalendarAppointment[] = []

  private ticketChangeSub: Subscription

  constructor(
    private calendarSrv: CalendarService,
    private feedback: FeedbackService,
    private navCtrl: NavController,
    private ticketSrv: TicketEmployee.TicketService,
    private authSrv: AuthService,
    private general: GeneralService,
    private ngZone: NgZone
  ) { 
  }

  ngOnInit(){
    
    
    // this.loadAppointments("init")

    this.ticketChangeSub = this.general.activeTicket.subscribe(async (ticket: {ticket: TicketBase}) => {
      if(ticket?.ticket?.id) await this.loadAppointments(ticket.ticket.id)
    })
  }

  ngOnDestroy(){
    this.ticketChangeSub?.unsubscribe()
  }

  private async loadAppointments(ticketId: number){
    const appointments: CalendarAppointment[] = await this.calendarSrv.getAppointmentsByTicketId(ticketId ?? 0)
    this.sortAppointments(appointments)
  }

  public async sortAppointments(appointments: CalendarAppointment[] = [...this.appointmentsUpcoming, ...this.appointmentsPast]){
    this.ngZone.run(() => {
      this.appointmentsUpcoming = appointments.filter(a => dayjs(a.startDateMoment.format("YYYY-MM-DD HH:mm:ss")).isSameOrAfter(dayjs()))
      this.appointmentsUpcoming = this.appointmentsUpcoming.sort((a, b) => a.startDateMoment.isBefore(b.startDateMoment) ? -1 : 1)

      this.appointmentsPast = appointments.filter(a => dayjs(a.startDateMoment.format("YYYY-MM-DD HH:mm:ss")).isBefore(dayjs()))
      this.appointmentsPast = this.appointmentsPast.sort((a, b) => a.startDateMoment.isBefore(b.startDateMoment) ? 1 : -1)
    })

  }

  public async onDelete(appointment: CalendarAppointment){
    this.ngZone.run(() => {
      this.appointmentsPast = this.appointmentsPast.filter(a => a.id != appointment.id)
      this.appointmentsUpcoming = this.appointmentsUpcoming.filter(a => a.id != appointment.id)
    })
  }

  /**
   * Öffnet den Kalender in einem Modal
   */
  public async openCalendar(){
    if(!window.matchMedia("(max-width: 1050px)").matches)
      await this.feedback.openModal(CalendarPage, {isModal: true}, () => {}, true, [], "calendar-modal")
    else
      await this.navCtrl.navigateForward('tabs/calendar-mobile') 
  }

  public async openAddAppointmentModal(){

        let createDate: dayjs.Dayjs = dayjs.utc().clone()

        createDate.utc().set("hours", dayjs().get("hours"))
        createDate.utc().set("minutes", dayjs().get("minutes"))
 
        let appointment: CalendarAppointment = new CalendarAppointment({
          id: -1,
          type: null,
          startDate: createDate.startOf("hour").toDate(),
          endDate: createDate.startOf("hour").add(1, "hour").toDate(),
          subject: "",
          appointment_Tickets: [
            { 
              ticketID: this.ticketSrv.ticket.id, 
              ticketsID: this.ticketSrv.activeWorkstepId
            } 
          ],
          attendees: [{
            employeeID: this.authSrv.getUser()?.id
          }]
        })
    
        await this.feedback.openModal(CalendarEditPopoverPage, {
          isModal: true,
          isNew: true,
          appointment
        }, async (result: HttpFunctionResult<CalendarAppointment>) => {
          if(!result.success) return

          await this.feedback.showLoading(async () =>{
            const createResult: HttpFunctionResult<CalendarAppointment> = await this.calendarSrv.createAppointment(result.data)
            if(!createResult.success) return
            this.appointmentsUpcoming.unshift(createResult.data)
            this.ngZone.run(() => this.sortAppointments())
          }, "Speichern...")
        })
  }

}
